import { useLazyContext } from "@redotech/react-util/context";
import { DiscountElement } from "@redotech/redo-content-builder-common/forge/review-forge-types";
import { memo, useContext } from "react";
import {
  DiscountSelector,
  DiscountsContext,
} from "../../discounts/discount-selector";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewsDiscount = memo(function ReviewsDiscount({
  element,
}: {
  element: DiscountElement;
}) {
  const brandKit = useContext(BrandKitContext);
  const fontFamily = brandKit.font.bodyFontFamily;
  const [discounts] = useLazyContext(DiscountsContext);
  const discount = discounts.value?.find(
    (d) => d._id.toString() === element.discountId,
  );
  const discountCode = discount?.codeGenerationStrategy.code ?? "XXXXXX";

  return (
    <Flex align="center" dir="column" justify="center" style={{ fontFamily }}>
      <Text fontSize="xs" fontWeight="bold" isHeader>
        {discountCode}
      </Text>
    </Flex>
  );
});

export const discountInspector: InspectorConfig<DiscountElement> = {
  sections: [
    {
      label: "Discount",
      fields: [
        {
          widget: "custom",
          label: "Discount",
          Element: (props) => (
            <DiscountSelector
              discountId={props.value.discountId}
              setDiscountId={(discountId) =>
                props.valueChange({ ...props.value, discountId })
              }
            />
          ),
        },
      ],
    },
  ],
};
